export default __webpack_public_path__ + "assets/2.dc4cc54c.png";